export const EMAIL_LOGIN_FORM_TEST_ID = "email-login-form";
export const FORGOT_PASSWORD_TEST_ID = "forgot-password";
export const OTHER_LOGIN_OPTIONS_TEST_ID = "other-login-options";
export const REGISTER_FOR_FREE_TEST_ID = "register-for-free";
